<ng-container *transloco="let t;">
        <div class="col-12 col-lg-6 col-md-12 pt-2 pb-2 pe-2 bulkUpload-rightColumn-border">
            <!-- <h2 class="bulk-info-section-title">Before uploading your file</h2> -->
        
            <div class="bulk-uplaod-info-list">
                <div class="bulk-info-list-left">
                    <i data-feather="book-open" class="font-medium-3"></i>
                </div>
                <div class="bulk-info-list-right">
                    <h3 class="bulk-info-list-title">
                        {{t('Data structure info title (bulk upload first step) - Learn SimpleSign data structure')}}
                    </h3>
                    <p class="bulk-info-list-desc">{{t('Data structure detail info (bulk upload first step) - Download and use our sample file to see exactly how we organize in SimpleSign')}}.</p>
        
                    <a class="csv-sample-file-text mt-50" target="_blank"  [href]="(exampleFilesUrl$ | async)?.xls" >{{t('Download xlsx (bulk upload first step) - Download .xlsx sample file')}}</a>
                    <a class="csv-sample-file-text" target="_blank" [href]="(exampleFilesUrl$ | async)?.csv">{{t('Download csv link title (bulk upload first step) - Download .csv sample file')}}</a>
                </div>
            </div>
        
            <div class="bulk-uplaod-info-list">
                <div class="bulk-info-list-left">
                    <i data-feather="server" class="font-medium-3"></i>
                </div>
                <div class="bulk-info-list-right">
                    <h3 class="bulk-info-list-title">
                        {{ t('Fill in mandatory fields info title (bulk upload first step) - Fill in mandatory fields') }}
                    </h3>
                    <p class="bulk-info-list-desc">{{t('Fill in mandatory fields details (bulk upload first step) - Certain fields needs to entered in order for you import to be successful. Make sure they are complete before you start importing')}}.</p>
                </div>
            </div>
        
            <div class="bulk-uplaod-info-list">
                <div class="bulk-info-list-left">
                    <i data-feather="sliders" class="font-medium-3"></i>
                </div>
                <div class="bulk-info-list-right">
                    <h3 class="bulk-info-list-title">
                        {{ t('Custom fields (bulk upload first step) - Create custom fields') }}
                    </h3>
                    <p class="bulk-info-list-desc"> {{t('Custom fields details (bulk upload first step) - Some data fields may not be present by default. Make sure you create these custom fields before importing your data')}}.</p>
                </div>
            </div>
        
            <div class="bulk-uplaod-info-list">
                <div class="bulk-info-list-left">
                    <i data-feather="file-text" class="font-medium-3"></i>
                </div>
                <div class="bulk-info-list-right">
                    <h3 class="bulk-info-list-title">
                        {{ t('Uploading files title (bulk upload first step) - Uploading files') }}
                    </h3>
                    <p class="bulk-info-list-desc">{{t('Uploading files details (bulk upload first step) - File uploads are accessible in the final step')}}.</p>
                </div>
            </div>
        </div>
        
        <div class="col-12 col-lg-6 col-md-12 pt-2 pb-2 ps-2">
            <form [formGroup]="form">
            <div class="background-wrapper file-drop-zone" (fileDropped)="onFileDropped($event)" appDropFiles>
                <input #csvFile class="fileDrop" type="file"  (change)="onFileDropped($event)" [accept]="acceptableFiles"/>
                <div class="upload-icon-img ">
                    <img src="../../../../assets/images/icons/uploadIcon-files.png">
                </div>
                <span class="font-weight-500">{{ t('Drag and drop section (bulk upload first step) - Upload contracts or drag and drop') }}</span>
                <span class="csv-file-supported-text">{{t('Drag and drop allowed files (bulk upload first step) - (.xls and .xlsx) and .csv file types are supported')}}.</span>
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                @if(form.get('file')?.value){
                    <div class="file-name-wrapper ">
                            <span class="csv-file-supported-text file-name">{{ form.get('file')?.value.name }}</span>
                            <span class="ms-75 m-0 remove-file cursor-pointer text-danger" container="body" placement="auto"
                                  [autoClose]="true"
                                  triggers="hover"
                                  [ngbTooltip]="t('Delete (general) - Delete')"
                                  (click)="deleteFile()">
                                   <i class="" [size]="14" data-feather="x"></i>
                            </span>
                     
                    </div>
                    }
                    @if(submitted){
                        <div class="text-center">
                            @if(form.get('file')?.hasError('required')){
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ t('Field required (form validation) - Field name is required', {
                                    fieldName: t('Drag and drop section, field name (bulk upload first step) - file')}) }}
                                </div>
                            }
                            
                            @if(form.get('file')?.hasError('maxSize')){
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ form.get('file')?.errors?.maxSize?.message }}
                                </div>
                            }

                            @if(form.get('file')?.hasError('unsupportedFileType')){
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ form.get('file')?.errors.unsupportedFileType }}
                                </div>
                            }
                        </div>
                    }
            
            </div>
            
            <div class="row pt-1">
                <div class="col-4 d-flex align-items-center">
                    <label class="me-1" for="">{{t('Document type label (general) - Document type')}}</label>
                 </div>
                <div class="col-8 d-flex align-items-center">
                    <ng-select
                        #SelectSizeDefault
                        [items]="(documentTypes$ | async) | documentTypeSelectorFor: '3'"
                        [searchable]="false"
                        formControlName="document_type_id"
                        bindLabel="document_type"
                        bindValue="id"
                        class="ng-select-modal-dropdown-panel bulk-upload-select w-100"
                        [placeholder]="t('Document type label (general) - Document type')"
                    >
                        <ng-template ng-header-tmp>
                            <input
                                    class="form-control w-100"
                                    type="text"
                                    (input)="SelectSizeDefault.filter($event.target.value)"
                            />
                        </ng-template>
                    </ng-select>
                </div>
                <div *ngIf="submitted && form && form.get('document_type_id').errors"
                     class="invalid-feedback d-block">
                    <div *ngIf="form.get('document_type_id').errors.required">
                        {{t('Field required (form validation) - Field name is required',{
                        fieldName: t('Document type label (general) - Document type')}) }}
                    </div>
                </div>
            </div>
            </form>
        </div>

</ng-container>
